import React, {ReactElement} from 'react';
import './index.scss';

const ErrorReloadPage: React.FC = (): ReactElement => {
  return (
    <div className="error-reload-container">
      <div className="error-header">Something went wrong.</div>
      <div className="error-subheader">Try reloading the page.</div>
    </div>
  );
};

export default ErrorReloadPage;
